import "./ColorPalet/percent.css";

/**
 * 
 * @param {number} value porcentaje que queremos obtner color
 * @returns clase con el background especifico para el porcentaje
 */
export function getColorPercent( value) {
  if( value >= 100){
    return "bg-100-absolute";
  }
  else{
    if( value <= 0){
      return "bg-0-absolute";
    }else{
      let aux = parseInt(value / 10) * 10;
      return "bg-"+aux;
    }
  }
}